import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

function isSelected(option, options) {
  return options.indexOf(option) >= 0;
}

const parseValue = value => {
  if (value === "" || value === null || value === undefined) {
    return [];
  }

  return Array.isArray(value) ? value : [value];
};

const SubItems = ({
  title,
  onBack,
  onSelect,
  options,
  selected,
  value,
  name,
  onSearchChange,
  searchValue,
  multiply
}) => {
  const [internalValue, setInternalValue] = useState(() => parseValue(value));

  const handleSelect = value => {
    const clonedValue = [...internalValue];

    const index = clonedValue.findIndex(
      found => JSON.stringify(found) === JSON.stringify(value)
    );

    if (index === -1) {
      clonedValue.push(value);
    } else {
      clonedValue.splice(index, 1);
    }

    const newValue = multiply
      ? clonedValue
      : clonedValue[clonedValue.length - 1];

    onSelect({ [name]: newValue });
  };

  useEffect(() => {
    if (JSON.stringify(internalValue) !== JSON.stringify(value)) {
      setInternalValue(parseValue(value));
    }
  }, [value]);

  return (
    <div className="plus-control__controls">
      <div className="plus-control__item back" onClick={onBack}>
        Назад
      </div>

      <div className="plus-control__item-section">{title}</div>

      {onSearchChange && (
        <div className="plus-control__search-item">
          <input
            type="text"
            className="plus-control__search-input"
            value={searchValue}
            onChange={onSearchChange}
          />
          <span className="plus-control__search-icon" />
        </div>
      )}

      <div className="plus-control__options">
        {options.map(option => (
          <div
            key={option.value}
            className={classnames("plus-control__item shifted", {
              active:
                internalValue.findIndex(
                  found =>
                    JSON.stringify(found) === JSON.stringify(option.value)
                ) !== -1
            })}
            onClick={() => {
              handleSelect(option.value);
            }}
          >
            {option.name}
          </div>
        ))}
      </div>
    </div>
  );
};

SubItems.propTypes = {
  title: PropTypes.string,

  onBack: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,

  options: PropTypes.array,
  value: PropTypes.any,

  name: PropTypes.string,

  multiply: PropTypes.bool
};

SubItems.defaultProps = {
  options: []
};

export default SubItems;
